import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    channels: { get, set, deleteEndpoint, qr, sendConnectionAPIToken, new: newChannel, uri, update },
  },
} = config

/**
 * Get channels
 * @param {string} company
 * @param {object} paramsQuery
 * @param {string} [paramsQuery.delegation] delegation filter
 * @param {string} [paramsQuery.channel] filter by channel
 * @param {string} [paramsQuery.provider] filter by provider
 * @param {boolean} [paramsQuery.channelList] Get channel list and schemas only
 */
const getChannels = (company, paramsQuery = {}) =>
  axios.get(get.replace(':idCompany', company), {
    headers: getHeaders(true),
    params: { ...paramsQuery },
  })

const postChannel = (company, credential, channel) =>
  axios.post(set.replace(':idCompany', company).replace(':channel', channel), { credential }, { headers: getHeaders(true) })
const updateChannel = (company, body, channel) =>
  axios.put(set.replace(':idCompany', company).replace(':channel', channel), body, {
    headers: getHeaders(true),
  })
const deleteChannel = (channelID, companyID) =>
  axios.delete(deleteEndpoint.replace(':id', companyID).replace(':channel', channelID), {
    headers: getHeaders(true),
  })

const postChannelQr = (channel) => axios.post(qr, channel, { headers: getHeaders(true) })

const postSendConnectionAPIToken = () => axios.post(sendConnectionAPIToken, {}, { headers: getHeaders(true) })

const postChannelNew = (credential) => axios.post(newChannel, { credential }, { headers: getHeaders(true) })

const updateChannelNew = (channelID, data) => axios.put(update.replace(':channelID', channelID), data, { headers: getHeaders(true) })

const getUri = (data) => axios.post(uri, data, { headers: getHeaders(true) })

export default {
  getChannels,
  updateChannel,
  postChannel,
  deleteChannel,
  postChannelQr,
  postSendConnectionAPIToken,
  postChannelNew,
  getUri,
  updateChannelNew,
}
